import { Component, inject, OnInit } from '@angular/core';
import { GestionProvenanceService } from '@services/navigation/gestion-provenance.service';

@Component({
  selector: 'app-bouton-retour',
  templateUrl: './bouton-retour.component.html',
  standalone: false,
})
export class BoutonRetourComponent implements OnInit {
  private readonly gestionProvenanceService = inject(GestionProvenanceService);
  estProvenanceExterne!: boolean;

  ngOnInit() {
    this.estProvenanceExterne = this.gestionProvenanceService.estProvenanceExterne();
  }
}
